var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardDuibiIconNormal = function SvgNewcsDashboardDuibiIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_duibi_icon_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M125 205h20v18h-20z",
    "data-name": "\\u77E9\\u5F62 470"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_duibi_icon_normal_svg__a)",
    transform: "translate(-125 -205)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M135 223a2 2 0 0 1-2-2v-2h-6a2 2 0 0 1-2-1.949v-10.052a2 2 0 0 1 2-2h8a2 2 0 0 1 1.98 1.72 2 2 0 0 1 .02.281v2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2Zm-.5-2a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-6v4.5l2.573-2.573a.25.25 0 0 1 .427.176v6.793a.25.25 0 0 1-.427.176L137 217a2 2 0 0 1-2 2h-.5Zm.5-3.5a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.239-.426.5.5 0 0 0-.261-.074h-8a.5.5 0 0 0-.5.5v10.039a.5.5 0 0 0 .5.462zm5-.5v-2h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5Zm-10-1.6V213h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1.5v-2.4a.25.25 0 0 1 .427-.177l3.4 3.4a.25.25 0 0 1 0 .354l-3.4 3.4a.25.25 0 0 1-.175.074.25.25 0 0 1-.252-.251",
    "data-name": "\\u8054\\u5408 74"
  }))));
};
export default SvgNewcsDashboardDuibiIconNormal;